import * as React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";

export const DismissCanonicalEntityDialog = ({ open, setOpen, onConfirm }) => {
  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      fullWidth
      slotProps={{
        paper: {
          component: "form",
          sx: { backgroundImage: "none" },
        },
      }}
    >
      <DialogTitle>Add Misconception</DialogTitle>
      <DialogContent>
        Are you sure you want to remove this? This cannot be undone.
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpen(false)} variant={"outlined"}>
          Cancel
        </Button>
        <Button onClick={() => onConfirm()} variant={"contained"}>
          Remove
        </Button>
      </DialogActions>
    </Dialog>
  );
};
